import { IBLSpinLoader, PathwayItems } from '../../../components';
import { getContentCompletionData, getUserName, useProgram } from '../../../hooks';
import { useTranslation } from 'react-i18next';
import React, { useEffect, useState } from 'react';

export const ProgramViewContent = ({ programID }) => {
  const [program, programLoaded, programCourses, programCoursesLoaded] =
    useProgram({ programID });
  const descriptionContent = program?.data?.description ?? ""

  const { t } = useTranslation('library');

  const [completionData, setCompletionData] = useState({
    completion_percentage:null,
    count:0
  })

  const handleCompletionDataFetch = () =>{
    getContentCompletionData({
      program_key: program?.program_key,
      username:getUserName()
    }, 'program', (data)=>{
      setCompletionData({
        completion_percentage: Math.floor(data.completion_percentage),
        count: data?.count
      })
    })
  }

  useEffect(() => {
    if(programLoaded && program?.program_key){
      handleCompletionDataFetch()
    }
  }, [programLoaded]);

  return (
    <div className="pathway">
      <div className="div-block-110">
        <div className="pathway_div">
          <div className="div-block-121">
            {
              completionData?.completion_percentage ? (
                  <div className="content-progress-bar-block-container">
                    <div className="w-layout-vflex content-progress-bar-block full-floating">
                      <div className="w-layout-hflex content-progress-bar-top-block font-bigger">
                        <div className="w-layout-hflex flex-block-67"><img
                          src="/images/circle-check-big.svg"
                          loading="lazy" alt="" className="image-240" />
                          <div className="content-progress-bar-title">Progress</div>
                        </div>
                        <div className="content-progress-bar-percentage">{completionData?.completion_percentage}%</div>
                      </div>
                      <div className="content-progress-bar-slider-block more-height">
                        <div className="content-progress-bar-slider-percentage-block" style={{
                          width: `${completionData?.completion_percentage}%`
                        }}></div>
                      </div>
                    </div>
                  </div>
              ) :
                <></>
            }
          </div>
          <div className="text-block-58">
            {programLoaded ? program?.name : ''}
          </div>
          <div className="div-block-75">
            <div className="p_header">
              <div className="text-block-39 wide p_t wt">
                {programLoaded ? program?.name : ''}
              </div>
              <div
                className="unit-wide-description people profile_description p_t wto"
                prop-data-names="stat"
                prop-data-value-stat="32 Items - 8 sections - 7 Hours"
              >
                {programCoursesLoaded
                  ? `${programCourses?.length || 0} ${' ' + t('Courses')}`
                  : ''}
              </div>
            </div>
          </div>
        </div>
        {descriptionContent && (
          <div className="p_about">
            <div className="text-block-57" prop-data-names="description">
              {descriptionContent}
            </div>
          </div>
        )}
      </div>
      <div className="p_outline">
        {
          !programCoursesLoaded ? <IBLSpinLoader size={40} containerHeight={"200px"} /> : programCourses.map((data, index) => {
            return (
              <PathwayItems key={index} data={data} index={index} />
            );
          })
        }
      </div>
    </div>
  );
};
